export const XDC_NETWORK_PARAMS = {
    chainId: `0x${parseInt("50").toString(16)}`,
    chainName: 'XDC Network',
    rpcUrls: ['https://rpc.xdcrpc.com'],
    nativeCurrency: {
        name: 'XDC',
        symbol: 'XDC',
        decimals: 18,
    },
    blockExplorerUrls: ['https://xdcscan.io'],
};

export const XDC_APOTHEM_NETWORK_PARAMS = {
    chainId: `0x${parseInt("51").toString(16)}`,
    chainName: 'XDC Apothem Network',
    rpcUrls: ['https://erpc.apothem.network'],
    nativeCurrency: {
        name: 'TXDC',
        symbol: 'TXDC',
        decimals: 18,
    },
    blockExplorerUrls: ['https://explorer.apothem.network'],
};
export const Luxe_NETWORK_PARAMS = {
    chainId: `0x${parseInt("1122").toString(16)}`,
    chainName: 'LuxePorts',
    rpcUrls: ['https://rpc.luxeports.com/'],
    nativeCurrency: {
        name: 'LuxePorts',
        symbol: 'LXP',
        decimals: 18,
    },
    blockExplorerUrls: ['https://lxpscan.com/'],
};
const chainConfig = Object.freeze({
    xdc: XDC_NETWORK_PARAMS,
    apothem: XDC_APOTHEM_NETWORK_PARAMS,
    luxe: Luxe_NETWORK_PARAMS,
});

export default chainConfig;